import React, { useContext, useEffect, useState } from 'react'
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { UiButton } from '../../../_uiComponents/common/form/UiButton';
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import UiSearch from "../../../_uiComponents/common/form/UiSearch";
import ParticipantResponse from './ParticipantUserResponse';
import { DataGrid } from '@mui/x-data-grid';
import {
    ApprovedIcon,
    NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";
import { useDispatch } from 'react-redux';
import { dataTemplateGetUserAccountListRequest, dataTemplateParticipantUserAccountCreateRequest } from '../../../../_redux/_actions';
import { useSelector } from 'react-redux';



export default function ParticipantUserInformation(props) {

    const [state, dispatch] = useContext(Context);
    const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
    const [searchData, setSearchData] = useState(null);
    const [checkedData, setCheckedData] = useState([]);

    const actionDispatch = useDispatch();


    const { userList } = useSelector((state) => {
        return {
            userList: state.dataTemplate.participantUser
        };
   });


    useEffect(() => {
        actionDispatch(
            dataTemplateGetUserAccountListRequest({
                 id:props.id
            })
       )
    },[]);


    const rows = userList.map((item, index) => ({
        id: index + 1,
        ...item
    }));

    const handleRowSelectionModelChange = (event) => {
        const filteredObjects = rows.filter((object) => {
         const { id } = object;
         return event.some((value) => value === id);
       });
       setCheckedData(filteredObjects);
     };


    const columns = [

        {
            field: 'email',
            headerName: 'Email',
            type: 'text',
            align: 'left',
            headerAlign: 'left',
            width: 270,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },
        {
            field: 'firstName',
            headerName: 'First Name',
            type: 'text',
            align: 'left',
            headerAlign: 'left',
            width: 185,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },
        {
            field: 'lastName',
            headerName: 'Last Name',
            type: 'text',
            align: 'left',
            headerAlign: 'left',
            width: 185,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },
        {
            field: 'dealerCode',
            headerName: 'Dealer',
            type: 'text',
            align: 'left',
            headerAlign: 'left',
            width: 185,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },
        {
            field: 'jobRole',
            headerName: 'Job Role',
            type: 'text',
            align: 'left',
            headerAlign: 'left',
            width: 185,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
        },
        {
            field: 'manager',
            headerName: 'Manager',
            type: 'text',
            align: 'center',
            headerAlign: 'center',
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,
            renderCell: (params) => {
                return (
                    <>
                        {params.row.manager ? <ApprovedIcon /> : <NotApprovedIcon />}
                    </>

                )
            }
        }

    ];

    const openSuccess = () => {
        dispatch({
            type: contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL,
            payload: {
                show: true,
                heading: 'Participant User',
                children: <ParticipantResponse />
            },
        });
    };


    const createParticipantUsers = () => {
        actionDispatch(dataTemplateParticipantUserAccountCreateRequest({
            openSuccess,
            participantDataTemplateId:props.id,
            participantEmailList:checkedData.map(participant => participant.email)
        }
        ))
    }

    const clearParticipantUsers = () => {
        //console.log("Click");
        //setCheckedData([])
    }

    function CustomNoRowsOverlay() {
        return <div className="sba-no-data-row">No Data</div>;
    }

    const SearchUsers = (input) => {
        if(input.length !== 0){
            const searchItem = rows.filter(item =>
                Object.values(item).some(val =>
                    val ? val.toString().toLowerCase().includes(input.toLowerCase()) : false
                )
            );
            setSearchData(searchItem)
        }else {
            setSearchData(null);
        }
    }

    return (
        <>

            <div className="sba-participant-manage-search">
                <UiSearch
                    onChange={(e) => {SearchUsers(e)}}
                 />
            </div>
            <Grid container spacing={2} sx={{ mt: 0.2 }}>
                <Grid item xs={12} lg={12}>
                    <div className='sba-table-main-wr sba-manage-tb-wr'>

                        <DataGrid
                            rows={searchData === null ? rows : searchData}
                            columns={columns}
                            checkboxSelection
                            onRowSelectionModelChange={(e) => handleRowSelectionModelChange(e)}
                            slots={{
                                noRowsOverlay: CustomNoRowsOverlay,
                            }}
                            hideFooterPagination
                            hideFooter
                            pagination={false}
                        />
                    </div>

                </Grid>
                <Grid item xs={12} lg={12}>
                    <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                        <UiButton name="Clear" variant="outlined" size="small" onClick={clearParticipantUsers} />
                        <UiButton name="Create" variant="contained" size="small" onClick={createParticipantUsers} />
                    </Stack>
                </Grid>
            </Grid>

        </>
    )
}
